import React from 'react';
import { Search, User, Building2 } from 'lucide-react';
import CommonSearchInput from '../../common/CommonSearchInput';

/**
 * 뷰 모드(개인/회사/관리자)에 따라 다른 검색 필드들을 렌더링하는 컴포넌트.
 */
const SearchFilters = ({ 
    viewMode, 
    personalSearch, setPersonalSearch,
    companyNameSearch, setCompanyNameSearch,
    companyContentSearch, setCompanyContentSearch,
    adminCompanySearch, setAdminCompanySearch,
}) => {
    return (
        <>
            {viewMode === 'personal' && (
                <CommonSearchInput
                    value={personalSearch ?? ''}
                    onChange={(e) => setPersonalSearch?.(e.target.value)}
                    placeholder="질의 내용 검색"
                    icon={Search}
                />
            )}
            {viewMode === 'company' && (
                <>
                    <CommonSearchInput
                        value={companyNameSearch ?? ''}
                        onChange={(e) => setCompanyNameSearch?.(e.target.value)}
                        placeholder="이름"
                        icon={User}
                        containerClassName="w-full md:w-40"
                    />
                    <CommonSearchInput
                        value={companyContentSearch ?? ''}
                        onChange={(e) => setCompanyContentSearch?.(e.target.value)}
                        placeholder="질의 내용"
                        icon={Search}
                    />
                </>
            )}
            {viewMode === 'admin' && (
                <>
                    <CommonSearchInput
                        value={adminCompanySearch ?? ''}
                        onChange={(e) => setAdminCompanySearch?.(e.target.value)}
                        placeholder="회사명"
                        icon={Building2}
                        containerClassName="w-full md:w-44"
                    />
                    <CommonSearchInput
                        value={companyContentSearch ?? ''}
                        onChange={(e) => setCompanyContentSearch?.(e.target.value)}
                        placeholder="질의 내용"
                        icon={Search}
                    />
                </>
            )}
        </>
    );
};

export default SearchFilters;
